import { Task } from 'stores/tasks';
import { SelectFilterOperationType } from '../filters/select';
import { SingleSelectFieldFilter } from '../filters/single-select';
import { FilterFunction } from '.';

export const task_dependency_status = (
  filter: SingleSelectFieldFilter,
): FilterFunction => {
  switch ((filter as SingleSelectFieldFilter).type) {
    case SelectFilterOperationType.IsOneOf:
      return (record) =>
        ((record as Task).dependentTasks ?? []).filter((x) =>
          (filter as any).value.includes(
            x.fields?.find((y) => y.fieldName === 'Status')?.fieldValue,
          ),
        ).length > 0;
    case SelectFilterOperationType.IsNoneOf:
      return (record) =>
        ((record as Task).dependentTasks ?? []).filter((x) =>
          (filter as any).value.includes(
            x.fields?.find((y) => y.fieldName === 'Status')?.fieldValue,
          ),
        ).length === 0;
    case SelectFilterOperationType.Is:
      return (record) =>
        ((record as Task).dependentTasks ?? []).some(
          (x) =>
            x.fields?.find((y) => y.fieldName === 'Status')?.fieldValue ===
            (filter as any).value,
        );
    case SelectFilterOperationType.IsNot:
      return (record) =>
        ((record as Task).dependentTasks ?? []).every(
          (x) =>
            x.fields?.find((y) => y.fieldName === 'Status')?.fieldValue !==
            (filter as any).value,
        );
    default:
      return () => true;
  }
};
